import _ from 'lodash';
import BindedObject from './BindedObject';

export class Measure extends BindedObject {
  constructor(measure, data) {
    super(measure);
    this.data = data;
  }

  get agregates() {
    const {data, field} = this;
    return {
      average: () => (this.measure('sum') / this.measure('count')),
      count: () => (_(data).map(field).filter(v => v).size()),
      max: () => (_(data).map(field).max()),
      min: () => (_(data).map(field).min()),
      sum: () => (_(data).map(field).sum())
    };
  }

  measure(key) {
    return this.agregates[key]();
  }

  getValue() {
    return this.value || this.measure(this.type);
  }
}
